import { useState as e, useEffect as n } from "react";
const i = () => {
  const [i, t] = e("undefined" != typeof window ? window.innerWidth : 0);
  return n(() => {
    const e = () => {
      t(window.innerWidth);
    };
    return window.addEventListener("resize", e), () => window.removeEventListener("resize", e);
  }, []), {
    isMobile: i < 768,
    isTablet: i >= 768 && i < 1024,
    isDesktop: i >= 1024
  };
};
export { i as useScreenRecognition };